import { useMemo, useState } from 'react'
import { Printer } from 'lucide-react'
import { buildContainerLabelGroups, containerLabelsDocument, evenCopies } from '../lib/containerLabels'
import { printDocument } from '../lib/printMaterials'

export default function ContainerLabels({ menu, disabled, runPrint }) {
  const [copies, setCopies] = useState({})
  const groups = useMemo(() => buildContainerLabelGroups(menu, copies), [menu, copies])
  const count = groups.reduce((sum, g) => sum + g.items.length * g.copies, 0)
  return (
    <section className="card">
      <div className="card-header flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-display text-lg text-havn-green-900">Kitchen container labels</h2>
          <p className="text-xs text-havn-gray-500">For workers · 2 of each sauce and vegetable; 4 of each carb, raw protein and cooked protein. Add extras in pairs.</p>
        </div>
        <div className="flex gap-2">
          <button className="btn-secondary" disabled={disabled || !count} onClick={() => runPrint('kitchen-sheet', () => printDocument(containerLabelsDocument(groups, `${menu.name} — Kitchen containers`, true)))}>
            <Printer className="w-4 h-4" /> Letter sheets
          </button>
          <button className="btn-primary" disabled={disabled || !count} onClick={() => runPrint('kitchen-labels', () => printDocument(containerLabelsDocument(groups, `${menu.name} — Kitchen containers`)))}>
            <Printer className="w-4 h-4" /> Print {count} labels
          </button>
        </div>
      </div>
      <div className="p-4 grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        {groups.map((group) => (
          <div key={group.id} className="rounded-lg border border-havn-cream-300 p-3">
            <label className="flex items-center justify-between gap-2 text-sm font-semibold">
              {group.title}
              <select aria-label={`Copies per ${group.title.toLowerCase()} label`} className="input !w-16 !py-1" value={group.copies} onChange={(e) => setCopies((prev) => ({ ...prev, [group.id]: evenCopies(e.target.value) }))}>
                {Array.from({ length: 25 }, (_, i) => (i + 1) * 2).map((n) => <option key={n} value={n}>{n}</option>)}
              </select>
            </label>
            <p className="text-xs text-havn-gray-500 mt-1">{group.copies} each · {group.items.length * group.copies} labels</p>
            <ul className="mt-2 text-xs space-y-1">{group.items.map((item) => <li key={item.key}>{item.name}</li>)}</ul>
            {!group.items.length && <p className="text-xs text-havn-gray-500 mt-2">None on this menu</p>}
          </div>
        ))}
      </div>
      <p className="px-4 pb-4 text-xs text-havn-gray-500">2 × 1 in labels · raw and cooked proteins are marked separately · {Math.ceil(count / 40)} letter sheets. Print at 100% scale.</p>
    </section>
  )
}
